import db_tables from '@/api/data/db_tables';
export class ContactServerCustomer {
    constructor(ctx, common) {
        this.selfCustomerSyncLastTime = 'server_sync_self_customer_last_time_';
        this.selfCustomerSyncLastId = 'server_sync_self_customer_last_id_';
        this.customerSyncLastTime = 'server_sync_customer_last_time_';
        this.customerSyncLastId = 'server_sync_customer_last_id_';
        this.clueSyncLastTime = 'server_sync_clue_last_time_';
        this.clueSyncLastId = 'server_sync_clue_last_id_';
        this.contactGlobalDB = 'contact_global_db_upgrade_version';
        this.syncPullVersionCustomer = 'sync_pull_version_customer';
        this.syncPullVersionClue = 'sync_pull_version_clue';
        this.ctx = ctx;
        this.common = common;
    }
    async syncSelfCustomerList(lastId = 0) {
        const { success, data, error } = await this.common.retry(async () => {
            const url = this.ctx.systemApi.getUrl('getCustomerList');
            const res = await this.ctx.http.post(url, {
                lastId,
                mode: 0,
                lastUpdateTime: 0,
                onlySelf: 1,
            }, {
                contentType: 'json',
            });
            return res.data;
        });
        if (success && data && data.success && data.data) {
            const { items, lastId: _lastId } = data.data;
            const loadMore = items.length > 0;
            if (loadMore) {
                const ret = await this.syncSelfCustomerList(_lastId);
                return {
                    data: [...items, ...ret.data],
                    loadMore: false,
                };
            }
            return {
                data: items,
                loadMore,
            };
        }
        console.error('[contact_edm] syncCustomerList error', error);
        return Promise.reject(new Error('syncCustomerList error'));
    }
    async doGetCustomerListFromServer(params) {
        const url = this.ctx.systemApi.getUrl('getCustomerListPage');
        const res = await this.ctx.http.post(url, params, {
            contentType: 'json',
        });
        const { success, data, error } = res.data || {};
        if (success && data) {
            const { companyList = [] } = data;
            return companyList;
        }
        console.error('[contact_edm] doGetCustomerListFromServer error', error);
        return Promise.reject(new Error('doGetCustomerListFromServer error'));
    }
    async doGetCustomersFromServerBatch(params) {
        if (!Array.isArray(params.idList) || params.idList.length === 0) {
            return Promise.reject(new Error('doGetCustomerListFromServer error'));
        }
        const url = this.ctx.systemApi.getUrl('getCustomerDetailBatch');
        const reqParams = {
            companyIdList: params.idList,
        };
        const res = await this.ctx.http.post(url, reqParams, {
            contentType: 'json',
        });
        const { success, data, error } = res.data || {};
        if (success && data) {
            const { companyList = [] } = data;
            return companyList;
        }
        console.error('[contact_edm] doGetCustomerListFromServer error', error);
        return Promise.reject(new Error('doGetCustomerListFromServer error'));
    }
    async getVersionLastId(type) {
        const currentStoreData = type === 'customer' ? this.common.getStoreData(this.customerSyncLastId) : this.common.getStoreData(this.clueSyncLastTime);
        if (type === 'customer' && this.common.getStoreData(this.syncPullVersionCustomer)) {
            return Number(currentStoreData || 0);
        }
        if (type === 'clue' && this.common.getStoreData(this.syncPullVersionClue)) {
            return Number(currentStoreData || 0);
        }
        await this.ctx.contactDB.deleteCustomerDataInDB();
        return 0;
    }
    async syncCustomerList(force) {
        const contactGlobalDBVersion = Number(this.common.getStoreData(this.contactGlobalDB) || 0);
        let lastUpdateTime = Number(this.common.getStoreData(this.customerSyncLastTime) || 0);
        let lastId = await this.getVersionLastId('customer');
        if (contactGlobalDBVersion < db_tables.contact_global.version) {
            lastUpdateTime = 0;
            this.ctx.store.putSync(this.contactGlobalDB, db_tables.contact_global.version.toString());
        }
        if (force) {
            lastUpdateTime = 0;
            lastId = 0;
        }
        const { success, data, error } = await this.common.retry(async () => {
            const url = this.ctx.systemApi.getUrl('getCustomerList');
            const res = await this.ctx.http.post(url, {
                lastId,
                mode: 1,
                onlySelf: 0,
                lastUpdateTime,
            }, {
                contentType: 'json',
            });
            return res.data;
        });
        if (success && data && data.success && data.data) {
            const { items, lastId: _lastId, lastUpdateTime: _lastUpdateTime } = data.data;
            this.ctx.store.putSync(this.customerSyncLastId, _lastId);
            this.ctx.store.putSync(this.customerSyncLastTime, _lastUpdateTime);
            this.ctx.store.putSync(this.syncPullVersionCustomer, 'true');
            const loadMore = items.length > 0 && !(_lastId === lastId && lastUpdateTime === _lastUpdateTime);
            return {
                data: items,
                loadMore,
            };
        }
        console.error('[contact_edm] syncCustomerList error', error);
        return Promise.reject(new Error('syncCustomerList error'));
    }
    async syncClueList() {
        const lastId = await this.getVersionLastId('clue');
        const lastUpdateTime = Number(this.common.getStoreData(this.clueSyncLastTime) || 0);
        const { success, data, error } = await this.common.retry(async () => {
            const url = this.ctx.systemApi.getUrl('getClueList');
            const res = await this.ctx.http.post(url, {
                lastId,
                mode: 1,
                onlySelf: 0,
                lastUpdateTime,
            }, {
                contentType: 'json',
            });
            return res.data;
        });
        if (success && data && data.success && data.data) {
            const { items, lastId: _lastId, lastUpdateTime: _lastUpdateTime } = data.data;
            this.ctx.store.putSync(this.clueSyncLastId, _lastId);
            this.ctx.store.putSync(this.clueSyncLastTime, _lastUpdateTime);
            this.ctx.store.putSync(this.syncPullVersionCustomer, 'true');
            const loadMore = items.length > 0 && !(_lastId === lastId && lastUpdateTime === _lastUpdateTime);
            return {
                data: items,
                loadMore,
            };
        }
        console.error('[contact_edm] syncClueList error', error);
        return Promise.reject(new Error('syncClueList error'));
    }
    async getCustomerListFilterByManagerId(idList, page) {
        var _a, _b, _c;
        try {
            const { data } = await this.ctx.http.post(this.ctx.systemApi.getUrl('getCustomerListByMangerId'), {
                page,
                page_size: 1000,
            }, {
                contentType: 'json',
            });
            if ((data === null || data === void 0 ? void 0 : data.success) && (data === null || data === void 0 ? void 0 : data.data)) {
                let loadMore = false;
                const totalPage = ((_a = data.data) === null || _a === void 0 ? void 0 : _a.total_page) || 0;
                if (totalPage > page) {
                    loadMore = true;
                }
                let list = (_b = data.data) === null || _b === void 0 ? void 0 : _b.content;
                if (list === null || list === void 0 ? void 0 : list.length) {
                    const managerIdSet = new Set(idList);
                    list = list.filter(item => {
                        const managerList = item.manager_list || [];
                        let needReturn = false;
                        if (managerList.length > 0) {
                            needReturn = managerList.some((manager) => managerIdSet.has(manager.id));
                        }
                        if (!needReturn) {
                            console.warn('[contact_server] getCustomerListFilterByManagerId', item);
                        }
                        return needReturn;
                    });
                }
                return {
                    success: true,
                    data: {
                        list,
                        loadMore,
                        from: 'all',
                    },
                };
            }
            return {
                success: false,
                code: data === null || data === void 0 ? void 0 : data.code,
                message: data === null || data === void 0 ? void 0 : data.message,
            };
        }
        catch (error) {
            console.error('[contact_server] getCustomerListFilterByManagerId error', error);
            if (((_c = error === null || error === void 0 ? void 0 : error.data) === null || _c === void 0 ? void 0 : _c.code) === 40101) {
                return { success: true };
            }
            return {
                success: false,
                message: this.ctx.contactUtil.catchError(error),
            };
        }
    }
    async getCustomerListByManagerId(params) {
        var _a, _b;
        const { idList, page, from = 'filter' } = params;
        if (from === 'all') {
            return this.getCustomerListFilterByManagerId(idList, page);
        }
        try {
            const { data } = await this.ctx.http.post(this.ctx.systemApi.getUrl('getCustomerListByMangerId'), {
                page,
                page_size: 1000,
                quickFilter: {
                    relation: 'AND',
                    subs: [{ id: 'manager_list', condition: { method: 'ANY_OF', values: idList }, table: 'customer' }],
                },
            }, {
                contentType: 'json',
            });
            if ((data === null || data === void 0 ? void 0 : data.success) && (data === null || data === void 0 ? void 0 : data.data)) {
                let loadMore = false;
                const totalPage = ((_a = data.data) === null || _a === void 0 ? void 0 : _a.total_page) || 0;
                if (totalPage > 10) {
                    return this.getCustomerListFilterByManagerId(idList, page);
                }
                if (totalPage > page) {
                    loadMore = true;
                }
                return {
                    success: true,
                    data: {
                        list: data.data.content,
                        loadMore,
                        from: 'filter',
                    },
                };
            }
            return {
                success: false,
                code: data === null || data === void 0 ? void 0 : data.code,
                message: data === null || data === void 0 ? void 0 : data.message,
            };
        }
        catch (error) {
            console.error('[contact_server] getCustomerListByManagerId error', error);
            if (((_b = error === null || error === void 0 ? void 0 : error.data) === null || _b === void 0 ? void 0 : _b.code) === 40101) {
                return { success: true };
            }
            return {
                success: false,
                message: this.ctx.contactUtil.catchError(error),
            };
        }
    }
}
